import {custom, SKIP} from "serializr";

export class Schema {
    static primitive() {
        return custom((v) => {
            if (v === false || v === true) {
                return v ? 1 : SKIP;
            } else if (!isNaN(v)) {
                return v ? v : SKIP;
            } else {
                return v;
            }
        }, (v) => {
            return v;
        });
    }

    static number() {
        return custom(
          (v) => {
              if (typeof v === 'number') {
                  return v;
              } else {
                  console.log(`Expected number but got:`, v);
                  return SKIP;
              }
          },
          (v) => v
        );
    }

    static string() {
        return custom(
          (v) => {
              if (typeof v === 'string') {
                  return v;
              } else {
                  console.log(`Expected string but got:`, v);
                  return SKIP;
              }
          },
          (v) => v
        );
    }
}

